<script setup lang="ts">
import { pick } from 'radash';

const properties = defineProps<{
  item: any
}>()

const { locale, t } = useI18n()
const { getThumbnail: img } = useDirectusFiles()
const { request } = useDirectusRest()
const {fileUrl} = useFiles()

const { data: pricing } = await useAsyncData('bob-price', () =>
  request(
    readItems('pricing', {
      fields: ['bob'],
    }),
  ),
)

const packagePrice = computed(() => {
  const defaults = pick(properties.item, [
    'default_drink',
    'default_bob',
    'default_duration',
    'default_delivery_fee',
  ])

  if (
    properties.item?.locked ||
    Object.entries(defaults).every(([key, value]) => !value)
  ) {
    return properties.item?.price
  }

  const duration = defaults.default_duration?.duration || 1

  const bobCost = defaults.default_bob ? pricing.value.bob * duration : 0

  return (
    defaults.default_duration?.price +
    bobCost +
    defaults.default_delivery_fee?.price +
    defaults.default_drink?.price
  )
})
</script>

<template>
  <div @click="$emit('selected')" class="group !h-full w-full cursor-pointer">
    <div
      class="grid h-full grid-rows-[auto_1fr_auto] rounded-xl bg-white shadow duration-100 ease-in-out"
    >
      <div class="px-6 py-4">
        <h2 class="text-xl font-bold">
          {{ item?.translations[0]?.name || 'Pakket' }}
        </h2>
      </div>
      <div>
        <div class="aspect-[16/9] w-full">
          <NuxtImg
            :src="fileUrl(item.picture)"
            alt=""
            class="h-full w-full object-cover"
            crossorigin
            format="webp"
            height="200"
            quality="80"
            sizes="335px md:500px xl:300px"
            v-if="item?.picture"
            width="350"
          />
          
        </div>
        <div class="px-6 pt-8 font-bold">
          <p class="text-3xl">
            <span>
              {{
                formatNumber(packagePrice, locale, {
                  currency: 'EUR',
                  style: 'currency',
                })
              }}
            </span>
          </p>
          <!--
          <i18n-t keypath="price" tag="p" v-else>
            <template #price>
              <span class="block text-3xl">{{
                formatNumber(packagePrice, locale, {
                  currency: 'EUR',
                  style: 'currency',
                })
              }}
              </span></template>
          </i18n-t> -->
        </div>
        <div
          class="prose mt-4 px-6 pb-8 prose-p:my-0 prose-li:marker:text-sunglow-500"
          v-html="item.translations[0].description"
          v-if="item.translations[0].description"
        ></div>
      </div>
    </div>
    <div class="text-center">
      <button
        @click="$emit('selected')"
        class="-translate-y-1/2 rounded-lg bg-black p-3 font-semibold text-white shadow-lg duration-100 group-hover:scale-105 group-hover:text-sunglow-500 group-hover:shadow-xl"
      >
        {{ item.locked ? t('book_now') : t('assemble') }}
      </button>
    </div>
  </div>
</template>

<style lang="css" scoped>
.shadow {
  box-shadow: 4px 10px 20px rgba(0, 0, 0, 0.18);
}

/* Prose classes */
.prose ul {
  list-style: disc;
  list-style-position: outside;
  padding-left: 1.5rem;
}
</style>

<i18n lang="json">
{
  "nl": {
    "price": "vanaf {price}",
    "assemble": "Samenstellen",
    "book_now": "Boek nu"
  },
  "en": {
    "price": "from {price}",
    "assemble": "Assemble",
    "book_now": "Book now"
  },
  "fr": {
    "price": "à partir de {price}",
    "assemble": "Assemble",
    "book_now": "Réserver maintenant"
  }
}
</i18n>
